module.exports = {"items":[{"slug":"petition","title":"Petition"},{"slug":"position","title":"Organizations' Statement"},{"slug":"press-kit","title":"For the press"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/action-nav.en.json
// module id = 138
// module chunks = 0